import { createUseStyles } from 'react-jss';

const useStyle = createUseStyles((theme) => ({
  rate: {
    display: 'inline-flex',
    position: 'relative',
    alignItems: 'center',
    justifyContent: 'center',
    flexDirection: 'row',
    backgroundColor: theme.colors.background.normal,
    '&:not(.readonly)': {
      cursor: 'pointer',
    },
    '& svg': {
      stroke: theme.colors.background.normal,
      lineHeight: 1,
    },
  },
}));

export default useStyle;
